/**
 * Created by emma on 16/12/3.
 */
import $ from 'jquery';
import auth from '../account/login';
import stats from 'stats';

export default function ajax(data) {
    var beforeSend = data.beforeSend,
        success = data.success,
        error = data.error;
    return $.ajax($.extend({cache: false}, data, {
        beforeSend: function (xhr) {
            var info = auth.getInfo();
            xhr.setRequestHeader("X-YY-TOKEN", info.token);
            if (beforeSend) {
                beforeSend(xhr);
            }
        },
        success: function (result) {
            if (result && result.code == 40001) {
                window.location.href = "/login.html?callbackUrl=" + encodeURIComponent(location.href);
                return;
            }
            if (success) {
                success(result);
            }
        },
        error: function (xhr, errorType, _error) {
            stats.trackEvent('ajax', 'error', xhr.status, xhr.responseURL);
            if (error) {
                error(xhr, errorType, _error);
            }
        }
    }))
}


// WEBPACK FOOTER //
// ./components/util/ajax.js